const paths = {
  listTrackingUnits: '/trackingUnits/list',
  editTrackingUnits: '/trackingUnits/edit',
  listFleet: '/trackingUnits/fleet'
};

export default paths;
